import { MuiButton } from './button';
import { formComponents } from './forms';

export const components = {
  MuiButton,
  ...formComponents,
};
